module.exports = __webpack_public_path__ + "./docs/img/icon-howto.25657e93799c6b74ecb83ce0e3e12e4d.svg";